import React from "react";
import * as MdIcons from "react-icons/md";
import "./createButton.css";

export default function CreateButton({ onClick }) {
  return (
    <div className="button-wrapper">
      <button className="custom-btn" onClick={onClick}>
        <MdIcons.MdAdd size={20} />
        CREATE TEAM
      </button>
    </div>
  );
}
